import { Phone, Mail, Facebook, Youtube, Instagram } from "@/components/Icon";

const Dots = () => (
  <span className="flex flex-col gap-1 mx-4" aria-hidden="true">
    <span className="w-1 h-1 rounded-full bg-[#059594]" />
    <span className="w-1 h-1 rounded-full bg-[#059594]" />
    <span className="w-1 h-1 rounded-full bg-[#059594]" />
  </span>
);

const TopBar = () => {
  return (
    <div className="hidden md:block bg-[#0a2933] text-white text-xs font-semibold uppercase tracking-wide">
      <div className="container flex items-center justify-between h-11">
        <div className="flex items-center">
          <a
            href="mailto:info@magicprint.nl"
            className="flex items-center gap-2 hover:text-[#059594] transition-colors"
          >
            <Mail className="w-4 h-4 text-[#059594]" />
            <span>info@magicprint.nl</span>
          </a>
          <Dots />
          <a
            href="tel:+31708873306"
            className="flex items-center gap-2 hover:text-[#059594] transition-colors"
          >
            <Phone className="w-4 h-4 text-[#059594]" />
            <span>070 887 3306</span>
          </a>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://www.facebook.com/MagicPrint070/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <a
            href="https://www.instagram.com/magicprint070/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href="https://www.youtube.com/@MagicPrintDenHaag"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
          >
            <Youtube className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
